import './inhaltsverzeichnis.css';
import React, { useState, useEffect } from "react";
import { ArrowDownUp } from 'lucide-react';
import { useLocation, useNavigate } from "react-router-dom";

const db_api = "https://liedersammlung.com/api.php";

function escapeRegex(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function InhaltsverzeichnisKateg() {
  const [lieder, setLieder] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');
  const navigate = useNavigate();
  const location = useLocation();
  const selectedCategory = new URLSearchParams(location.search).get('kategorie') || '';

  const openSong = (id) => {
    navigate(`/lied/${id}`);
  };

  const toggleSortBy = () => {
    setSortBy((prevSort) => (prevSort === 'name' ? 'id' : 'name'));
  };
  const formatKategorie = (value) => {
    if (!value) return '';
    const withSpaces = value.replace(/_/g, ' ');
    const words = withSpaces.split(' ').filter(Boolean);
    const smallWords = new Set(['und', 'oder', 'vom', 'von', 'der', 'die', 'das', 'im', 'am', 'zum', 'zur']);
    return words
      .map((word, index) => {
        const lower = word.toLowerCase();
        if (index !== 0 && smallWords.has(lower)) return lower;
        return lower.charAt(0).toUpperCase() + lower.slice(1);
      })
      .join(' ');
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetch(db_api)
      .then(res => res.json())
      .then(data => setLieder(data))
      .catch(err => console.error(err));
  }, []);

  const visibleLieder = lieder
    .filter((lied) => {
      const term = searchTerm.toLowerCase().trim();
      const matchesSearch = lied.name.toLowerCase().includes(term) || String(lied.id).includes(term);
      const matchesCategory = !selectedCategory || lied.kategorie === selectedCategory;
      return matchesSearch && matchesCategory;
    })
    .sort((a, b) => {
      if (sortBy === 'id') {
        return a.id - b.id;
      }
      return a.name.localeCompare(b.name, 'de', { sensitivity: 'base' });
    });

  function renderHighlightedName(name) {
    const term = searchTerm.trim();
    if (!term) return name;

    const parts = name.split(new RegExp(`(${escapeRegex(term)})`, 'gi'));
    return parts.map((part, index) =>
      part.toLowerCase() === term.toLowerCase() ? <span className='search_match' key={`${name}-${index}`}>{part}</span> : part
    );
  }

  return (
    <div id='inhaltsverzeichnis_body'>
      <div className='heading_box'>
        <h2>{selectedCategory ? formatKategorie(selectedCategory) : 'Alle Lieder'}</h2>
        <button className='sort_toggle' onClick={toggleSortBy} title='Sortieren nach Nummer oder Titel' aria-label='Sortieren nach Nummer oder Titel'>
          <ArrowDownUp className='sort_icon' />
        </button>
      </div>
      <div className='search_box'>
        <input
          className='searchInput'
          value={searchTerm}
          onChange={(event) => setSearchTerm(event.target.value)}
          placeholder='Lied suchen...'
        />
      </div>
      {visibleLieder.map((lied) => (
        <div className='titelbtn' key={lied.id} onClick={() => openSong(lied.id)}>
          <div>{renderHighlightedName(lied.name)}</div>
          <div>{lied.id}</div>
        </div>
      ))}
    </div>
  );
}

export default InhaltsverzeichnisKateg;

